// @ts-ignore esModuleInterop
import React from 'react'
// @ts-ignore redux is not typed
import { connect } from 'react-redux'
import type { primitives } from '@adc/blueprint'
import type { FeatureFlags } from '@adc/ui-adc'
import BidBanner from '../components/bidBanner'
import { withModalHooks } from '../hooks/useModalFeatures'
type AuctionUser = primitives.AuctionUser

interface REOBidBannerProps {
  featureFlags: FeatureFlags
  user: AuctionUser
  similarProperties?: object[]
  refreshCurrentListing: () => void
}

const REOBidBanner = ({
  featureFlags,
  user,
  similarProperties,
  refreshCurrentListing,
}: REOBidBannerProps) => {
  // bidBanner has to be wrapped in a fragment to work, it seems to be rendered in another component as the child of the output of this component
  return (
    <>
      <BidBanner
        featureFlags={featureFlags}
        similarProperties={similarProperties}
        refreshCurrentListing={refreshCurrentListing}
        user={user}
      />
    </>
  )
}
const mapStateToProps = (store: any) => {
  return {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    user: store.user,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    similarProperties: store.propertyAnalytics.similarProperties || [],
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    featureFlags: store.featureFlags,
  }
}

export default connect(mapStateToProps)(withModalHooks(REOBidBanner))
